import { render, staticRenderFns } from "./dd-command.vue?vue&type=template&id=d5b862b4&"
import script from "./dd-command.vue?vue&type=script&lang=ts&"
export * from "./dd-command.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports